<template>
	<div style="padding-bottom: 60px;overflow: hidden;">
		<div class="inbox">
			<page-header>
				<h3 slot="header">缩略图 组件 thumbnail</h3>
			</page-header>
			<breadcrumb :data="$store.state.bcArray"></breadcrumb>
		</div>
		<bsfcol size="xs" col="3">
			<panel header="缩略图组件">
				<thumbnail slot="body" :unbd="true">
					<img slot="img" src="~../../assets/logo.png" />
					<template slot="caption">
						<h4>thumbnail label name</h4>
						<p class="text-justify">Cras justo odio, dapibus ac facilisis in, egestas eget quam. Donec id elit non mi porta gravida at eget metus. Nullam id dolor id nibh ultricies vehicula ut id elit.</p>
					</template>
				</thumbnail>
			</panel>
		</bsfcol>
		<bsfcol size="xs" col="3">
			<panel header="缩略图组件 只有图片">
				<thumbnail slot="body">
					<img slot="img" src="~../../assets/logo.png" />
				</thumbnail>
			</panel>
		</bsfcol>
		<bsfcol size="xs" col="3">
			<panel header="缩略图组件 只有caption">
				<thumbnail slot="body">
					<template slot="caption">
						<h4>thumbnail label name</h4>
						<p class="text-justify">Cras justo odio, dapibus ac facilisis in, egestas eget quam. Donec id elit non mi porta gravida at eget metus. Nullam id dolor id nibh ultricies vehicula ut id elit.</p>
					</template>
				</thumbnail>
			</panel>
		</bsfcol>
		<bsfcol size="xs" col="3">
			<panel header="缩略图组件 没有边框">
				<thumbnail slot="body">
					<img slot="img" src="~../../assets/logo.png" />
					<template slot="caption">
						<h4>thumbnail label name</h4>
						<p class="text-justify">Cras justo odio, dapibus ac facilisis in, egestas eget quam. Donec id elit non mi porta gravida at eget metus. Nullam id dolor id nibh ultricies vehicula ut id elit.</p>
					</template>
				</thumbnail>
			</panel>
		</bsfcol>
		<bsfcol size="xs" col="6">
			<panel header="缩略图组件 和swiper组件结合使用" :tooltip="true">
				<thumbnail slot="body" :unbd="true">
					<swiper slot="img" height="300" mouse>
						<div class="swiper-slide" slot="slide" v-for="(slider,index) in swiperData">
							<img slot="img" src="~../../assets/logo.png" />
						</div>
					</swiper>
					<template slot="caption">
						<h4>thumbnail label name</h4>
						<p class="text-justify">Cras justo odio, dapibus ac facilisis in, egestas eget quam. Donec id elit non mi porta gravida at eget metus. Nullam id dolor id nibh ultricies vehicula ut id elit.</p>
					</template>
				</thumbnail>
			</panel>
		</bsfcol>
	</div>
</template>
<script>
	import layout from "components/css/layout"
	import bsfcol from "components/css/col"
	//
	import panel from 'components/comp/panel'
	import progress from 'components/comp/progress'
	import pageHeader from 'components/comp/pageheader'
	import breadcrumb from 'components/comp/breadcrumbs'
	import thumbnail from 'components/comp/thumbnail'
	import swiper from 'components/comp/swiper'
	//
	//
	export default {
		components: {
			layout,
			bsfcol,
			//
			pageHeader,
			panel,
			breadcrumb,
			thumbnail,
			swiper
		},
		data() {
			return {
				navdata1: [{
					name: "Home",
					href: ""
				}, {
					name: "Profile",
					href: ""
				}, {
					name: "Message",
					href: "",
					active: true
				}],
				swiperData: [{
					name: "信息",
					tit: "tit"
				}, {
					name: "信息1",
					tit: "tit1"
				}, {
					name: "信息2",
					tit: "tit2"
				}, {
					name: "信息3",
					tit: "tit3"
				}],
				bcArray: []
			}
		},
		computed: {

		}
	}
</script>
<style lang="less">

</style>


// WEBPACK FOOTER //
// thumbnail.vue?e2c03e96